// extracted by mini-css-extract-plugin
export default {"header":"styles_header__zfWgp","innerHeader":"styles_innerHeader__Lfn2s","logo":"styles_logo__5rFHa"};